import React from 'react';
import pipelineModel from './model/pipelineModel';
import { SelectBasePrototype } from 'clad';

export const SelectPipeline = React.forwardRef((props, ref) => {
    const { data, value, onChange, mode, placeholder, labelInValue } = props;

    const handleFetch = ({ query, id, pagination }) =>
        pipelineModel.list({ query, id, pagination });

    return (
        <SelectBasePrototype
            mode={mode}
            placeholder={placeholder || _('Select a pipeline')}
            schema={{ idOption: 'id', option: 'rule_name' }}
            fetch={handleFetch}
            onChange={onChange}
            value={value}
            data={data}
            labelInValue={labelInValue || false}
        />
    );
});
